import { render, staticRenderFns } from "./Momenta.vue?vue&type=template&id=65d9af7a&"
import script from "./Momenta.vue?vue&type=script&lang=js&"
export * from "./Momenta.vue?vue&type=script&lang=js&"
import style0 from "./Momenta.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports